import { DefaultError } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/default-error/component';
import { DrmErrorUnknown } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/drm-error/unknown';
import { DrmErrorUnsupported } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/drm-error/unsupported';
import { NetworkError } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/network-error/component';
import { RegionalError } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/regional-error/component';
import { TooManyConcurrentStreamsError } from '@/scenarios/legacy-player/components/feature-player/ui/player-errors/too-many-concurrent-streams-error/component';

enum SkinError {
    Default = 'DefaultSkinError',
}

export enum PlayerError {
    Internal = 'InternalPlayerError',
    Loading = 'LoadingPlayerError',
}

export enum ConcurrencyArbiterError {
    Hard = 'TooManyConcurrentStreams',
}

export type AppErrors =
    | SkinError
    | PlayerError
    | StreamsWatchingRejectionReason
    | ConcurrencyArbiterError;

// На бэке: https://a.yandex-team.ru/arcadia/kinopoisk/backend/gateway/kp-graphql-api/src/main/java/ru/yandex/kinopoisk/graphql/api/client/ott/availability/model/WatchingRejection.java?rev=r14220764
// Ссылка на дельту со списком сгруппированных ошибок https://delta.yandex-team.ru/page/epad/page/jd1e331lquhnazrb
export enum StreamsWatchingRejectionReason {
    YASP_FETCH_MANIFEST_BAD_HTTP_STATUS = 'YASP_FETCH_MANIFEST_BAD_HTTP_STATUS',
    YASP_FETCH_MANIFEST_TIMEOUT = 'YASP_FETCH_MANIFEST_TIMEOUT',
    YASP_FETCH_MANIFEST_HTTP_ERROR = 'YASP_FETCH_MANIFEST_HTTP_ERROR',
    YASP_FETCH_SEGMENT_TIMEOUT = 'YASP_FETCH_SEGMENT_TIMEOUT',
    YASP_FETCH_SEGMENT_BAD_HTTP_STATUS = 'YASP_FETCH_SEGMENT_BAD_HTTP_STATUS',
    YASP_FETCH_SEGMENT_HTTP_ERROR = 'YASP_FETCH_SEGMENT_HTTP_ERROR',
    INTERNET_UNAVAILABLE = 'INTERNET_UNAVAILABLE',
    DEADLINE_EXCEEDED = 'DEADLINE_EXCEEDED',
    NETWORK_ERROR = 'NETWORK_ERROR',
    MANIFEST_LOAD_ERROR = 'manifestLoadError',

    YASP_DASH_CONFLICTING_KEY_IDS = 'YASP_DASH_CONFLICTING_KEY_IDS',
    YASP_DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED = 'YASP_DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED',
    CONTENT_ID_MISMATCH = 'CONTENT_ID_MISMATCH',
    INTERNAL_BROADCAST_AUTH_TOKEN_IS_NOT_SET = 'INTERNAL_BROADCAST_AUTH_TOKEN_IS_NOT_SET',
    MISSING_PERSISTENT_FLAG = 'MISSING_PERSISTENT_FLAG',
    WIDEVINE_CLIENT_BAD_REQUEST = 'WIDEVINE_CLIENT_BAD_REQUEST',
    CLIENT_CDM_BAD_REQUEST_ERROR = 'CLIENT_CDM_BAD_REQUEST_ERROR',
    CLIENT_INVALID_CONTENT_ID_FORMAT = 'CLIENT_INVALID_CONTENT_ID_FORMAT',
    BAD_SPC = 'BAD_SPC',
    UNABLE_TO_PARSE_SPC = 'UNABLE_TO_PARSE_SPC',
    EXPECTED_MEDIA_KEYS_VERSION_V2 = 'EXPECTED_MEDIA_KEYS_VERSION_V2',
    WATCHABLE_CONSTRAINT_VIOLATION = 'WATCHABLE_CONSTRAINT_VIOLATION',
    INTERSECTION_BETWEEN_LICENSE_AND_STREAMS_NOT_FOUND = 'INTERSECTION_BETWEEN_LICENSE_AND_STREAMS_NOT_FOUND',
    MONETIZATION_MODEL_CONSTRAINT_VIOLATION = 'MONETIZATION_MODEL_CONSTRAINT_VIOLATION',
    PURCHASABLE_CONSTRAINT_VIOLATION = 'PURCHASABLE_CONSTRAINT_VIOLATION',
    DOWNLOADABLE_CONSTRAINT_VIOLATION = 'DOWNLOADABLE_CONSTRAINT_VIOLATION',
    LICENSE_TYPES_NOT_AVAILABLE = 'LICENSE_TYPES_NOT_AVAILABLE',
    LICENSE_HAS_EXPIRED = 'LICENSE_HAS_EXPIRED',
    WRONG_SUBSCRIPTION = 'WRONG_SUBSCRIPTION',

    NO_DRM_SYSTEMS = 'NO_DRM_SYSTEMS',
    CLIENT_INVALID_KEY_ID = 'CLIENT_INVALID_KEY_ID',
    CLIENT_UNKNOWN_KEY_ID_VERSION = 'CLIENT_UNKNOWN_KEY_ID_VERSION',
    SIGNATURE_VERSION_NOT_SUPPORTED = 'SIGNATURE_VERSION_NOT_SUPPORTED',
    OLD_CDM_DETAILS = 'CLIENT_CDM_OLD_ERROR',
    CLIENT_CDM_REVOKED_PERMANENTLY_ERROR = 'CLIENT_CDM_REVOKED_PERMANENTLY_ERROR',
    CLIENT_CDM_NOT_TRUSTED_ERROR = 'CLIENT_CDM_NOT_TRUSTED_ERROR',
    TAMPERED_DEVICE = 'TAMPERED_DEVICE',
    INCOMPATIBLE_PROTOCOL_VERSION = 'INCOMPATIBLE_PROTOCOL_VERSION',
    CLIENT_INVALID_ASSET_DATA_V1_FORMAT = 'CLIENT_INVALID_ASSET_DATA_V1_FORMAT',
    CLIENT_INVALID_ASSET_DATA = 'CLIENT_INVALID_ASSET_DATA',
    ASSET_DATA_MISMATCH = 'ASSET_DATA_MISMATCH',
    MISSING_HEADER_VERSION = 'MISSING_HEADER_VERSION',
    CLIENT_MISSING_KEY_ID = 'CLIENT_MISSING_KEY_ID',
    MISSING_CUSTOM_DATA_FIELD = 'MISSING_CUSTOM_DATA_FIELD',
    INCORRECT_CHECKSUM = 'INCORRECT_CHECKSUM',
    KEY_SEED_NOT_FOUND = 'KEY_SEED_NOT_FOUND',
    CONTENT_KEYS_NOT_FOUND = 'CONTENT_KEYS_NOT_FOUND',
    BAD_KEK = 'BAD_KEK',
    INCONSISTENT_CONTENT_ID_HASH = 'INCONSISTENT_CONTENT_ID_HASH',
    INVALID_KEY_ID_SIZE = 'INVALID_KEY_ID_SIZE',
    INVALID_KEY_SEED_SIZE = 'INVALID_KEY_SEED_SIZE',
    INVALID_CONTENT_ID_SIZE = 'INVALID_CONTENT_ID_SIZE',
    V2_KEY_ID_MISSING_CONTENT_ID_HASH = 'V2_KEY_ID_MISSING_CONTENT_ID_HASH',
    CLIENT_SUPPORTED_STREAM_NOT_AVAILABLE = 'CLIENT_SUPPORTED_STREAM_NOT_AVAILABLE',
    NO_CDM_6004 = 'shaka.INVALID_SERVER_CERTIFICATE_6004',
    NO_CDM_6002 = 'shaka.FAILED_TO_CREATE_CDM_6002',
    NO_CDM = 'NO_CDM',
    OLD_CDM_CODE = 'DRM_PROXY_ERROR',
    NO_DRM = 'NO_DRM',
    NO_DRM_OLD = 'NO_DRM_OLD',
    DRM_INIT_ERROR = 'DRM_INIT_ERROR',

    GEO_CONSTRAINT_VIOLATION = 'GEO_CONSTRAINT_VIOLATION',
    REGIONAL_LIMITATION_MANIFEST = 'REGIONAL_LIMITATION_MANIFEST',
    LICENSES_NOT_FOUND = 'LICENSES_NOT_FOUND',

    DEFAULT = 'DEFAULT',
    EMPTY_OTT_STREAMS = 'EMPTY_OTT_STREAMS',

    PURCHASE_NOT_FOUND = 'PURCHASE_NOT_FOUND',
    PURCHASE_EXPIRED = 'PURCHASE_EXPIRED',
    SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
    CONTENT_NOT_FOUND = 'CONTENT_NOT_FOUND',
}

export const defaultError = StreamsWatchingRejectionReason.DEFAULT;

export const errorMap: Record<AppErrors, React.FC> = {
    [StreamsWatchingRejectionReason.YASP_FETCH_MANIFEST_BAD_HTTP_STATUS]: NetworkError,
    [StreamsWatchingRejectionReason.YASP_FETCH_MANIFEST_TIMEOUT]: NetworkError,
    [StreamsWatchingRejectionReason.YASP_FETCH_MANIFEST_HTTP_ERROR]: NetworkError,
    [StreamsWatchingRejectionReason.YASP_FETCH_SEGMENT_TIMEOUT]: NetworkError,
    [StreamsWatchingRejectionReason.YASP_FETCH_SEGMENT_BAD_HTTP_STATUS]: NetworkError,
    [StreamsWatchingRejectionReason.YASP_FETCH_SEGMENT_HTTP_ERROR]: NetworkError,
    [StreamsWatchingRejectionReason.INTERNET_UNAVAILABLE]: NetworkError,
    [StreamsWatchingRejectionReason.DEADLINE_EXCEEDED]: NetworkError,
    [StreamsWatchingRejectionReason.NETWORK_ERROR]: NetworkError,
    [StreamsWatchingRejectionReason.MANIFEST_LOAD_ERROR]: NetworkError,

    [StreamsWatchingRejectionReason.YASP_DASH_CONFLICTING_KEY_IDS]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.YASP_DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.CONTENT_ID_MISMATCH]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.INTERNAL_BROADCAST_AUTH_TOKEN_IS_NOT_SET]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.MISSING_PERSISTENT_FLAG]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.WIDEVINE_CLIENT_BAD_REQUEST]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.CLIENT_CDM_BAD_REQUEST_ERROR]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.CLIENT_INVALID_CONTENT_ID_FORMAT]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.BAD_SPC]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.UNABLE_TO_PARSE_SPC]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.EXPECTED_MEDIA_KEYS_VERSION_V2]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.WATCHABLE_CONSTRAINT_VIOLATION]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.INTERSECTION_BETWEEN_LICENSE_AND_STREAMS_NOT_FOUND]:
        DrmErrorUnknown,
    [StreamsWatchingRejectionReason.MONETIZATION_MODEL_CONSTRAINT_VIOLATION]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.PURCHASABLE_CONSTRAINT_VIOLATION]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.DOWNLOADABLE_CONSTRAINT_VIOLATION]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.LICENSE_TYPES_NOT_AVAILABLE]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.WRONG_SUBSCRIPTION]: DrmErrorUnknown,

    [StreamsWatchingRejectionReason.CLIENT_INVALID_KEY_ID]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_UNKNOWN_KEY_ID_VERSION]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.SIGNATURE_VERSION_NOT_SUPPORTED]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_CDM_REVOKED_PERMANENTLY_ERROR]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_CDM_NOT_TRUSTED_ERROR]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.TAMPERED_DEVICE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INCOMPATIBLE_PROTOCOL_VERSION]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_INVALID_ASSET_DATA_V1_FORMAT]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_INVALID_ASSET_DATA]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.ASSET_DATA_MISMATCH]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.MISSING_HEADER_VERSION]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_MISSING_KEY_ID]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.MISSING_CUSTOM_DATA_FIELD]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INCORRECT_CHECKSUM]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.KEY_SEED_NOT_FOUND]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CONTENT_KEYS_NOT_FOUND]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.BAD_KEK]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INCONSISTENT_CONTENT_ID_HASH]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INVALID_KEY_ID_SIZE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INVALID_KEY_SEED_SIZE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.INVALID_CONTENT_ID_SIZE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.V2_KEY_ID_MISSING_CONTENT_ID_HASH]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.CLIENT_SUPPORTED_STREAM_NOT_AVAILABLE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.DRM_INIT_ERROR]: DrmErrorUnsupported,

    [StreamsWatchingRejectionReason.GEO_CONSTRAINT_VIOLATION]: RegionalError,
    [StreamsWatchingRejectionReason.REGIONAL_LIMITATION_MANIFEST]: RegionalError,
    [StreamsWatchingRejectionReason.LICENSES_NOT_FOUND]: RegionalError,

    [StreamsWatchingRejectionReason.DEFAULT]: DefaultError,
    [StreamsWatchingRejectionReason.EMPTY_OTT_STREAMS]: DefaultError,

    // until https://st.yandex-team.ru/KP-58291
    [StreamsWatchingRejectionReason.LICENSE_HAS_EXPIRED]: DrmErrorUnknown,
    [StreamsWatchingRejectionReason.PURCHASE_NOT_FOUND]: DefaultError,
    [StreamsWatchingRejectionReason.PURCHASE_EXPIRED]: DefaultError,
    [StreamsWatchingRejectionReason.SUBSCRIPTION_NOT_FOUND]: DefaultError,
    [StreamsWatchingRejectionReason.CONTENT_NOT_FOUND]: DefaultError,
    [StreamsWatchingRejectionReason.NO_CDM_6004]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.NO_CDM_6002]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.NO_CDM]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.OLD_CDM_CODE]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.OLD_CDM_DETAILS]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.NO_DRM]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.NO_DRM_OLD]: DrmErrorUnsupported,
    [StreamsWatchingRejectionReason.NO_DRM_SYSTEMS]: DrmErrorUnsupported,

    [SkinError.Default]: DefaultError,
    [PlayerError.Internal]: DefaultError,
    [PlayerError.Loading]: DefaultError,

    [ConcurrencyArbiterError.Hard]: TooManyConcurrentStreamsError,
};
